import React, { FC } from "react";

export interface IDeviceShadow {
  offsetX: number;
  offsetY: number;
  image: string;
}

interface IProps {
  x: number;
  y: number;
  iconSize: number;
  devices: IDeviceShadow[];
}

const DragSelected: FC<IProps> = (props) => {
  const { x, y, iconSize, devices } = props;

  return (
    <div style={{ position: "absolute", top: 0, left: 0 }}>
      {devices.map((shadow, key) => (
        <img
          key={key}
          src={shadow.image}
          alt="device icon"
          style={{
            position: "absolute",
            left: x - iconSize / 2 - shadow.offsetX,
            top: y - iconSize / 2 - shadow.offsetY,
            height: iconSize + "px",
            width: iconSize + "px",
            zIndex: "3",
            opacity: ".6",
          }}
        ></img>
      ))}
    </div>
  );
};

export default DragSelected;
